import Request from './../request';
import Util from './../util';


class FileMeta {
    constructor(options) {
        // Default settings
        let defaults = {
            api: '',
            path: '/api/upload',
            queryParams: {},
        };

        // Merge options into defaults
        this.settings = Util.extend(defaults, options || {});

        this.findToken();
    }

    findToken(){
        // check if a token cookie is already set
        let tokenValue = Util.readCookie('token');
        if(tokenValue) {
            // we pass the token via url for CORS support
            this.settings.queryParams.token = tokenValue;
        }
    }

    blobToFile(blob, fileName){
        return new File([blob], fileName, { lastModified: new Date().getTime(), type: blob.type })
    }

    fromBlob(blob, name){
        return {
            name: name,
            size: blob.size,
            mimeType: blob.type,
            meta: {},
            _file: blob // blob reference for file upload,  // INFO: blobToFile not required for upload
        };
    }

    fromNative(nativeFile) {
        return {
            name: nativeFile.name ? nativeFile.name : '',
            size: nativeFile.size,
            mimeType: nativeFile.type,
            meta: {},
            _file: nativeFile // keep native file reference,
        };
    }

    saveFile(fileMeta) {

        // NEW: check token again if not set yet - global storage would be nicer, but this breaks the this.settings.queryParams which is per instance
        // FIX for multiple upload fields with each their own fileMeta instance use same token if one instance has stored it on the cookie
        if(!this.settings.queryParams.token) {
            this.findToken();
        }

        // NEW: set origin to indicate where the upload came from ( which app )
        if(this.settings.origin){
            fileMeta.origin = this.settings.origin;
        }

        let request = new Request(this.settings.api + this.settings.path, {
            method: 'POST',
            responseType: 'json',
            headers: {
                'Content-type': 'application/json'
            },
            data: fileMeta,
            queryParams: this.settings.queryParams
        });

        return request
            .then((response) => {

                // store token in cookie if not already saved
                // IMPORTANT: this only works because we always store the original first and after that we we store the child files
                if(!this.settings.queryParams.token) {
                    // token is returned on the fileMeta element
                    if(response.data.token){
                        let token = response.data.token;
                        // make token valid for 10 days
                        Util.writeCookie('token', token, 10, '/');
                        // store for future request
                        this.settings.queryParams.token = token;
                    }
                }

                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    removeFile(fileMeta){
        /* DEPRECATED: we never fetch the file again so it not required to update the server (expensive db query)
        let request = new Request(this.settings.api + this.settings.path + '/' + fileMeta.uuid, {
            method: 'DELETE',
            responseType: 'json',
            queryParams: this.settings.queryParams,
        });

        return request
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });

         */

        // default promise
        return Promise.resolve();
    }

    exportFailed(error){

        // serialize error object
        if(typeof error === 'object'){
            // xhr serialized is empty - read fields manually (_url is set by our ajax-watch logic)
            if(error.xhr){
                error.xhr = { url: error.xhr._url, status: error.xhr.status, statusText: error.xhr.statusText };
            }
            error = JSON.stringify(error, Object.getOwnPropertyNames(error))
        }

        let request = new Request(this.settings.api + this.settings.path + '/export', {
            method: 'POST',
            responseType: 'text',
            headers: {
                'Content-type': 'application/json'
            },
            data: error,
            queryParams: this.settings.queryParams
        });

        return request
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}

export default FileMeta;
